import React from 'react';
import PropTypes from 'prop-types';
import { Impression } from '@nerdwallet/analytics/react/impression';
import { Button, Text, Title } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import styles from './campaign-highlight.module.less';

const CampaignHighlight = ({
  backgroundColor,
  backgroundColorMobile,
  title,
  titleEnd,
  titlePreColor,
  titleEndColor,
  subtitle,
  ctaButtonText,
  ctaLinkUrl,
  visualBackgroundImageUrl,
  visualBackgroundImageAlt,
  elementImpressionEntityName,
  elementImpressionSectionName,
  trkQueryParam,
}) => {
  const backgroundImageStyleDesktop = {
    backgroundColor: `${backgroundColor}`,
    backgroundImage: `url(${visualBackgroundImageUrl})`,
    backgroundSize: `cover`,
  };

  const backgroundImageStyleMobile = {
    backgroundColor: `${backgroundColorMobile}`,
  };

  const titlePreStyle = {
    color: `${titlePreColor}`,
  };

  const titleEndStyle = {
    color: `${titleEndColor}`,
  };

  return (
    <Impression
      entityName={elementImpressionEntityName}
      payload={{ section_name: elementImpressionSectionName }}
    >
      <div className={styles.campaignHighlight}>
        <div
          className={styles.campaignHighlightCta}
          style={{ backgroundColor }}
        >
          <Title size="small" className={styles.campaignHighlightCtaTitle}>
            <span
              className={styles.campaignHighlightCtaTitlePre}
              style={titlePreStyle}
            >
              {title}
            </span>
            <span
              className={styles.campaignHighlightCtaTitleEnd}
              style={titleEndStyle}
            >
              {'\u00A0'}
              {'\u00A0'}
              {titleEnd}
            </span>
          </Title>
          <div className={styles.campaignHighlightCtaText}>
            <Text>{subtitle}</Text>
          </div>
          <Button
            href={`${ctaLinkUrl}?trk=${trkQueryParam}`}
            className={styles.campaignHighlightCtaButton}
          >
            {ctaButtonText}
          </Button>
        </div>
        <div
          className={styles.campaignHighlightVisualContainerMobile}
          style={backgroundImageStyleMobile}
        >
          <Image
            backgroundColor={backgroundColorMobile}
            src={visualBackgroundImageUrl}
            alt={visualBackgroundImageAlt}
            imageClassName={styles.campaignHighlightVisualImageMobile}
            width="100%"
            naturalWidth="1170"
            naturalHeight="822"
            lazy
          />
        </div>
        <div
          className={styles.campaignHighlightVisualContainerDesktop}
          style={backgroundImageStyleDesktop}
        />
      </div>
    </Impression>
  );
};

CampaignHighlight.propTypes = {
  backgroundColor: PropTypes.string,
  backgroundColorMobile: PropTypes.string,
  title: PropTypes.string,
  titleEnd: PropTypes.string,
  titlePreColor: PropTypes.string,
  titleEndColor: PropTypes.string,
  subtitle: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaLinkUrl: PropTypes.string,
  visualBackgroundImageUrl: PropTypes.string,
  visualBackgroundImageAlt: PropTypes.string,
  elementImpressionEntityName: PropTypes.string,
  elementImpressionSectionName: PropTypes.string,
  trkQueryParam: PropTypes.string,
};

CampaignHighlight.displayName = 'CampaignHighlight';

export default CampaignHighlight;
